module.exports = __webpack_public_path__ + "static/media/hero-720.bbdcc224.jpg";